import ColorSwatches from "~/components/ColorSwatches/ColorSwatches";
import TokenTable from "~/components/TokenTable/TokenTable";
import * as React from 'react';
export default {
  ColorSwatches,
  TokenTable,
  React
};